/*
* Copyright (c) 2019 Honeywell International, Inc. All rights reserved.
*
* This file contains trade secrets of Honeywell International, Inc.  No part
*  may be reproduced or transmitted in any form by any means or for any
*  purpose without the express written permission of Honeywell.
*
*/
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'adminapp-raw-data-discovery-wrapper',
  templateUrl: './raw-data-discovery-wrapper.component.html',
  styleUrls: ['./raw-data-discovery-wrapper.component.scss']
})
export class RawDataDiscoveryWrapperComponent implements OnInit {
  constructor() { }

  ngOnInit() {
  }

}
